exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".display-initial {\n  display: initial; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/complaints/complaints-resolution/components/grid-complaint/grid-complaint.component.scss
// module id = 1999
// module chunks = 66